export default __webpack_public_path__ + "static/media/simple-icons_qt.7eb6e271.svg";